import * as React from "react";
import Svg, { Path } from "react-native-svg";

function SvgComponent({ height = "162", width = "134", ...props }) {
  return (
    <Svg
      width={width}
      height={height}
      viewBox="0 0 162 134"
      fill="none"
      {...props}
    >
      <Path
        d="M80.52 133.689c44.471 0 80.521-2.08 80.521-4.645 0-2.566-36.05-4.646-80.52-4.646S0 126.478 0 129.044c0 2.565 36.05 4.645 80.52 4.645z"
        fill="#E6E6E6"
      />
      <Path
        d="M126.612 44.971s-2.401-.857-3.944 2.572c-1.543 3.43-3.944 7.202-3.944 7.202l1.372.343s.343-2.4 1.2-2.744l-.343 3.087s10.288 3.6 14.918-.343l-.172-1.2s.686.171.686 1.2l.515-.514s-.515-1.03-2.058-2.401c-1.013-.9-1.361-2.613-1.48-3.684a4.463 4.463 0 00-1.027-2.428c-1.025-1.189-2.894-2.452-5.723-1.09z"
        fill="#2F2E41"
      />
      <Path
        d="M112.513 74.388l2.245 2.858 1.429-1.633-1.225-2.04-2.449.816zM111.697 118.266l-.816 4.285 2.041 1.02 1.428-1.02v-4.285h-2.653zM125.982 118.266l.816 4.285-2.04 1.02-1.429-1.02v-4.285h2.653z"
        fill="#FBBEBE"
      />
      <Path
        d="M117.615 79.695l-2.857 20.407-4.081 18.571 4.898.612 3.877-17.346 4.898-14.693-.613 17.55-1.02 14.489h3.673l2.653-19.59 2.934-14.566-.077-5.434h-14.285zM112.309 122.141s-1.02-1.224-1.632-.612c-.613.612-2.041 3.061-2.041 3.061s-3.265 1.837-.612 2.245c2.653.408 3.469 0 3.469-.204s.408-.817.408-.817l1.02.204 1.429-.408s.612-3.76 0-3.614c-.612.145-1.837.757-2.041.145zM125.37 122.141s1.02-1.224 1.633-.612c.612.612 2.04 3.061 2.04 3.061s3.265 1.837.612 2.245c-2.652.408-3.469 0-3.469-.204s-.408-.817-.408-.817l-1.02.204-1.429-.408s-.612-3.76 0-3.614c.612.145 1.837.757 2.041.145z"
        fill="#2F2E41"
      />
      <Path
        d="M127.308 55.513a4.081 4.081 0 10.001-8.163 4.081 4.081 0 00-.001 8.163z"
        fill="#FBBEBE"
      />
      <Path
        d="M130.064 53.982s-.409 3.47-.205 4.286c.205.816.613 2.04.613 2.04l-6.531-1.224s1.837-3.877 1.429-4.49c-.408-.612 4.694-.612 4.694-.612z"
        fill="#FBBEBE"
      />
      <Path
        d="M130.676 58.88l-6.735-1.429-3.877 23.673a8.84 8.84 0 015.306.204c2.857 1.02 6.734 0 6.734 0l-.816-22.244-.612-.204z"
        fill="#E40046"
      />
      <Path
        d="M125.313 55.576l-2.392 1.263-3.061.612-3.265 7.755.408 5.51s-3.469 6.326-3.878 9.795c0 0 .409 5.306 7.143 5.102l4.49-12.448s1.836-9.388 0-12.04c0 0 1.314-4.975.555-5.549z"
        fill="#2F2E41"
      />
      <Path
        d="M121.084 57.45l-.661-.112-.563.113s-1.429.204-3.061 1.632c-1.633 1.429-7.143 5.918-7.551 7.143-.408 1.224-.204 3.265.408 4.49.612 1.224 1.837 2.856 1.837 2.856l.612 1.429 3.469-1.02s-2.245-4.286-2.041-6.123l4.082-3.265 3.469-7.142zM129.837 56.498l3.083 3.81 1.633 2.04-2.041 6.938-1.02 5.918s2.449 9.388.408 12.245c0 0-1.224 1.428-1.633-.204-.408-1.633-.408-9.388-.408-9.388s-1.632-10.203-.816-12.856c.816-2.653-.044-8.027.794-8.503z"
        fill="#2F2E41"
      />
      <Path
        d="M132.716 86.02v2.041s-.408 6.734 1.633 5.918c2.041-.816.612-5.918.612-5.918l-.204-2.245-2.041.204z"
        fill="#FBBEBE"
      />
      <Path
        d="M122.759 51.65c1.552-1.123 2.808-2.417 3.64-3.956 0 0 2.848 3.165 4.589 3.323 1.74.158.158-3.798.158-3.798l-3.165-.791-3.007.316-2.373 1.583.158 3.323zM132.92 61.736l1.633.613.204 2.04.816 12.449-.408 9.387-3.061.204-1.02-10.408-.408-11.427 2.244-2.858z"
        fill="#2F2E41"
      />
      <Path
        d="M83.23 30.666h-.709V11.242A11.241 11.241 0 0071.28 0H30.128a11.242 11.242 0 00-11.242 11.242v106.56a11.242 11.242 0 0011.242 11.242h41.151a11.241 11.241 0 0011.242-11.242v-73.31h.71V30.666z"
        fill="#004170"
      />
      <Path
        d="M80.129 11.32v106.403a8.397 8.397 0 01-8.396 8.396h-41.35a8.398 8.398 0 01-8.395-8.396V11.32a8.396 8.396 0 018.396-8.396H35.4a3.99 3.99 0 003.693 5.495h23.575a3.99 3.99 0 003.694-5.495h5.37a8.396 8.396 0 018.397 8.396z"
        fill="#fff"
      />
      <Path d="M41.09 91.882h-.87l.29-16.986h.29l.29 16.986z" fill="#E6E6E6" />
      <Path
        d="M41.815 64.202l1.403-2.17a32.53 32.53 0 00-1.44-3.37l-.907.732.718-1.11c-.685-1.349-1.224-2.198-1.224-2.198s-2.815 4.436-3.755 9.133l1.801 2.784-1.994-1.61a13.175 13.175 0 00-.11 1.65c0 5.562 1.817 10.071 4.058 10.071 2.241 0 4.058-4.51 4.058-10.072 0-1.724-.39-3.529-.928-5.198l-1.68 1.358zM63.728 91.882h-.87l.29-16.986h.29l.29 16.986z"
        fill="#E6E6E6"
      />
      <Path
        d="M64.453 64.202l1.404-2.17a32.53 32.53 0 00-1.44-3.37l-.908.732.719-1.11c-.685-1.349-1.224-2.198-1.224-2.198s-2.816 4.436-3.756 9.133l1.801 2.784-1.994-1.61a13.156 13.156 0 00-.11 1.65c0 5.562 1.818 10.071 4.059 10.071 2.24 0 4.057-4.51 4.057-10.072 0-1.724-.39-3.529-.928-5.198l-1.68 1.358zM40.428 35.576a7.99 7.99 0 100-15.98 7.99 7.99 0 000 15.98zM51.495 89.408h-1.793l.598-35.023h.597l.598 35.023z"
        fill="#E6E6E6"
      />
      <Path
        d="M52.99 32.333l2.893-4.473a67.045 67.045 0 00-2.969-6.95l-1.871 1.511 1.482-2.29C51.112 17.351 50 15.6 50 15.6s-5.804 9.147-7.744 18.831l3.714 5.74-4.111-3.321a27.14 27.14 0 00-.226 3.402c0 11.47 3.746 20.768 8.367 20.768s8.367-9.298 8.367-20.768c0-3.556-.804-7.276-1.914-10.717l-3.465 2.798z"
        fill="#E6E6E6"
      />
      <Path
        d="M81.335 94.456v23.809a8.745 8.745 0 01-8.744 8.744H29.526a8.743 8.743 0 01-8.744-8.744V96.777a41.176 41.176 0 0160.553-2.321z"
        fill="#004170"
      />
      <Path
        opacity={0.2}
        d="M51.104 117.942c6.757 0 12.234-5.478 12.234-12.235s-5.477-12.234-12.234-12.234-12.235 5.477-12.235 12.234 5.478 12.235 12.235 12.235z"
        fill="#E40046"
      />
      <Path
        d="M51.104 115.56c5.44 0 9.85-4.411 9.85-9.851 0-5.441-4.41-9.852-9.85-9.852-5.441 0-9.852 4.411-9.852 9.852 0 5.44 4.411 9.851 9.852 9.851z"
        fill="#E40046"
      />
      <Path
        d="M48.984 111.159l-3.472-4.463 2.019-1.571 1.643 2.114 5.553-5.862 1.858 1.759-7.601 8.023z"
        fill="#fff"
      />
    </Svg>
  );
}

export default SvgComponent;
